module.exports = __webpack_public_path__ + "04d875a00d00766e0c4f1ab58f2e6d5e.png";